module.exports = __webpack_public_path__ + "static/media/plane(21).e3cbce03.PNG";